var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2c0b838323bad23c288da09027f940d5b042e64d"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["smarketerjobs-new@smarketer-gmbh"]={id:"2c0b838323bad23c288da09027f940d5b042e64d"};
      